var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFollowers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "#ececec",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24277 6.29649C7.78428 6.55975 6.58215 7.09728 7.31433 7.76992C7.67199 8.0985 8.07034 8.3335 8.57116 8.3335H11.4289C11.9297 8.3335 12.3281 8.0985 12.6858 7.76992C13.4179 7.09728 12.2158 6.55975 11.7573 6.29649C10.6822 5.67916 9.31793 5.67916 8.24277 6.29649Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2.9165C11.25 3.60686 10.6904 4.1665 10 4.1665C9.30964 4.1665 8.75 3.60686 8.75 2.9165C8.75 2.22615 9.30964 1.6665 10 1.6665C10.6904 1.6665 11.25 2.22615 11.25 2.9165Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6594 16.2965C13.2009 16.5597 11.9988 17.0973 12.731 17.7699C13.0886 18.0985 13.487 18.3335 13.9878 18.3335H16.8456C17.3464 18.3335 17.7447 18.0985 18.1024 17.7699C18.8346 17.0973 17.6324 16.5597 17.1739 16.2965C16.0988 15.6792 14.7346 15.6792 13.6594 16.2965Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 12.9165C16.6666 13.6069 16.107 14.1665 15.4166 14.1665C14.7263 14.1665 14.1666 13.6069 14.1666 12.9165C14.1666 12.2261 14.7263 11.6665 15.4166 11.6665C16.107 11.6665 16.6666 12.2261 16.6666 12.9165Z",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82603 16.2965C2.36753 16.5597 1.1654 17.0973 1.89758 17.7699C2.25524 18.0985 2.65359 18.3335 3.15441 18.3335H6.01218C6.513 18.3335 6.91134 18.0985 7.269 17.7699C8.00118 17.0973 6.79905 16.5597 6.34056 16.2965C5.26541 15.6792 3.90118 15.6792 2.82603 16.2965Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 12.9165C5.83337 13.6069 5.27373 14.1665 4.58337 14.1665C3.89302 14.1665 3.33337 13.6069 3.33337 12.9165C3.33337 12.2261 3.89302 11.6665 4.58337 11.6665C5.27373 11.6665 5.83337 12.2261 5.83337 12.9165Z",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 10.8335V12.9168M9.99996 12.9168L12.0833 14.1668M9.99996 12.9168L7.91663 14.1668",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFollowers);
export default __webpack_public_path__ + "static/media/icon-followers.ef47d3036d1a7125bb8943f7ad730d38.svg";
export { ForwardRef as ReactComponent };